// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__YiWBP","slick-next":"CustomSlider_slick-next__2-iGn"};